import dayjs from "dayjs";
import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { DATE_FORMATS } from "@/constants/date";
import { StyledChatMessage } from "./styled";

type Props = {
  message: string;
  date: string;
  name: string;
  isLast?: boolean;
};

const ChatMessage: FC<Props> = ({
  message,
  date,
  isLast,
  name,
}) => {
  const {t} = useTranslation();

  return (
    <StyledChatMessage $isLast={isLast}>
      <h5>{name || t('you')} <span>{dayjs(date).format(DATE_FORMATS.time)}</span></h5>
      <p>{message}</p>
    </StyledChatMessage>
  );
};

export default memo(ChatMessage);
